import React, { useEffect, useState } from 'react';
import useGetInputParams from './useGetInputParams';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import useGetPatientsForVisit from './useGetPatientsForVisit';
import useCacheDateFilterValue from './useCacheDateFilterValue';
import useCacheInputFilterValue from './useCacheInputFilterValue';

const usePatientsForVisit_Bl = (searchClause) => {
  const cachedDateRange =
    sessionStorage.getItem('dtr') &&
    JSON.parse(sessionStorage.getItem('dtr'));

  const initialDateRange = {
    FromDate: cachedDateRange?.fmd,
    ToDate: cachedDateRange?.td,
  };

  const [inputFilter, setInputFilter] = useState();
  const [range, setRange] = useState(
    () => initialDateRange
  );
  const [patientList, setPatientList] = useState('loading');

  const inputParams = useGetInputParams();
  const inputFilter_label = FindLangKey(
    'general-public-search-based-on'
  );

  const noData_label = FindLangKey(
    'general-public-flat-alert-no-data'
  );

  // console.log('inputFilterinputFilter--->', inputFilter);

  useGetPatientsForVisit(
    {
      inputFilter,
      range,
      searchClause,
    },
    setPatientList
  );

  useCacheDateFilterValue(range);
  useCacheInputFilterValue(inputFilter);

  useEffect(() => {
    return () => {
      sessionStorage.removeItem('inflv');
      // sessionStorage.removeItem('dtr');
    };
  }, []);

  return {
    setInputFilter,
    setRange,
    patientList:
      !range?.FromDate && !range?.ToDate && !inputFilter
        ? null
        : patientList,
    inputParams,
    inputFilter_label,
    noData_label,
  };
};

export default usePatientsForVisit_Bl;
